import api from './api';
import requester from './requester';

const loggingService = {
    checkServerStatus: () => requester(api.base).getOne(),
};

export default loggingService;
